module.exports = __webpack_public_path__ + "img/search_user.c40910ea.svg";